import { apiBasePath } from "../constants/constants";
import ApiService from "../utils/api-service";

export function getBootcampModuleViewApi(data) {
  let apiUrl = `${apiBasePath}/modules/${data.moduleId}`;

  if (
    data?.bootcampId !== undefined &&
    data?.bootcampId !== null &&
    data?.bootcampId !== ""
  ) {
    apiUrl += `?bootcampId=${data?.bootcampId}`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}

export function deleteBootcampModuleViewApi(data) {
  const options = {
    method: "DELETE",
    url: `${apiBasePath}/modules/${data.moduleId}`,
  };
  return ApiService(options);
}

export function getBootcampModuleBatchApi(data) {
  let apiUrl = `${apiBasePath}/moduleBatches?paginated=false`;

  if (data?.moduleId !== undefined) {
    apiUrl += `&moduleId=${data?.moduleId}`;
  }

  if (data?.bootcampId !== undefined) {
    apiUrl += `&bootcampId=${data?.bootcampId}`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function editBootcampModuleBatchApi(data) {
  const options = {
    method: "PATCH",
    url: `${apiBasePath}/moduleBatches`,
    data: data,
  };
  return ApiService(options);
}

export function deleteBootcampModuleBatchApi(data) {
  const options = {
    method: "DELETE",
    url: `${apiBasePath}/moduleBatches/${data.batchId}`,
  };
  return ApiService(options);
}

export function getBootcampApi(data) {
  let apiUrl = `${apiBasePath}/bootcamps?paginated=false&sortBy=startDate`;
  if (data?.endDate) {
    apiUrl += `&endDate=${data?.endDate}`;
  }
  if (data?.moduleId) {
    apiUrl += `&moduleId=${data?.moduleId}`;
  }
  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function editBootcampModuleApi(data) {
  const options = {
    method: "PATCH",
    url: `${apiBasePath}/modules`,
    data: data,
  };
  return ApiService(options);
}

export function addBatchCreateApi(data) {
  let apiUrl = `${apiBasePath}/moduleBatches`;

  const options = {
    method: "POST",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function addBatchReCreateApi(data) {
  let apiUrl = `${apiBasePath}/moduleBatches/generate?moduleId=${data?.moduleId}&recreate=true`;
  const options = {
    method: "POST",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function getRoomListApi(data) {
  let apiUrl = `${apiBasePath}/rooms`;

  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function getBootcampByIdApi({ bootcampId }) {
  let apiUrl = `${apiBasePath}/bootcamps/${bootcampId}`;

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}

export function getBatchAttendeesApi(data) {
  let apiUrl = `${apiBasePath}/moduleAttendees?paginated=false&sortBy=attendeeName&notInModule=true&status=ACTIVE`;

  if (data?.moduleId) {
    apiUrl += `&moduleId=${data?.moduleId}`;
  }

  if (data?.bootcampIds) {
    apiUrl += `&bootcampIds=${data?.bootcampIds}`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function createBulkBatchesApi(data) {
  let apiUrl = `${apiBasePath}/moduleBatches/autoCreate`;

  if (data?.moduleId) {
    apiUrl += `?moduleId=${data?.moduleId}`;
  }

  const options = {
    method: "POST",
    url: apiUrl,
    data: data,
  };
  return ApiService(options, true, true);
}
